<div class="relative w-full" [ngStyle]="{ width: width() || '100%' }">
	<div class="relative" (clickOutside)="closeDropdown()">
		<!-- Select container with proper styling -->
		<div
			#selectContainer
			[ngClass]="mergedContainerClass()"
			[class.border-gray-300]="
				!isRequiredState() || selectedValues().length > 0
			"
			[class.dark:border-gray-600]="
				!isRequiredState() || selectedValues().length > 0
			"
			[class.border-red-500]="
				isRequiredState() && selectedValues().length === 0
			"
			[class.dark:border-red-400]="
				isRequiredState() && selectedValues().length === 0
			"
			(click)="toggleDropdown()"
		>
			<!-- Floating label -->
			<label
				for="isRequiredState"
				*ngIf="label() !== ''"
				class="floating-label font-avertareguler !dark:bg-gray-700"
				[class.text-gray-900]="
					!isRequiredState() || selectedValues().length > 0
				"
				[class.dark:text-gray-100]="
					!isRequiredState() || selectedValues().length > 0
				"
				[class.text-red-500]="
					isRequiredState() && selectedValues().length === 0
				"
				[class.dark:text-red-400]="
					isRequiredState() && selectedValues().length === 0
				"
				[class.!dark:text-white]="
					!isRequiredState() || selectedValues().length > 0
				"
				[class.active]="selectedValues().length > 0 || isOpen()"
				[class.inactive]="selectedValues().length === 0 && !isOpen()"
			>
				{{ label() }}{{ isRequiredState() ? ' *' : '' }}
			</label>

			<div class="flex justify-between items-center">
				<!-- Selected items or placeholder -->
				<div class="flex-1" [style.min-width]="minWidth()">
					<span
						class="truncate text-gray-900 dark:text-gray-100 font-avertareguler"
						[class.text-gray-500]="selectedValues().length === 0"
						[class.dark:text-gray-400]="
							selectedValues().length === 0
						"
						[class.invisible]="
							(selectedValues().length === 0 && isOpen()) ||
							(selectedValues().length === 0 &&
								!isOpen() &&
								label() !== '')
						"
					>
						{{ getSelectionDisplayText() }}
					</span>
				</div>
				<svg
					class="h-5 w-5 text-gray-400 dark:text-gray-300"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 20 20"
					fill="currentColor"
					[class.text-indigo-500]="isOpen()"
					[class.dark:text-indigo-400]="isOpen()"
				>
					<path
						fill-rule="evenodd"
						d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
						clip-rule="evenodd"
					/>
				</svg>
			</div>
		</div>

		<!-- Dropdown that can position either top or bottom -->
		<div
			*ngIf="isOpen() && options().length > 0"
			[ngClass]="mergedDropdownClass()"
			[class.mt-1]="dropdownPosition() === 'bottom'"
			[class.mb-1]="dropdownPosition() === 'top'"
			[class.bottom-full]="dropdownPosition() === 'top'"
			[class.top-full]="dropdownPosition() === 'bottom'"
		>
			<!-- Search input section -->
			<div
				*ngIf="enableSearch()"
				class="px-3 py-2 border-b border-gray-200 dark:border-slate-700 bg-gray-50 dark:bg-slate-900 flex-shrink-0"
			>
				<div class="relative">
					<div
						class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
					>
						<svg
							class="h-4 w-4 text-gray-400 dark:text-gray-500"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
							/>
						</svg>
					</div>
					<input
						#searchInput
						type="text"
						class="block w-full pl-10 pr-8 py-2 border border-gray-200 dark:border-slate-600 rounded-md text-sm placeholder-gray-500 dark:placeholder-gray-400 bg-white dark:bg-slate-700 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400 focus:border-transparent"
						[placeholder]="searchPlaceholder()"
						[value]="searchTerm()"
						(input)="onSearchInput($event)"
						(click)="$event.stopPropagation()"
					/>
					<div
						*ngIf="searchTerm()"
						class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
						(click)="clearSearch()"
					>
						<svg
							class="h-4 w-4 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M6 18L18 6M6 6l12 12"
							/>
						</svg>
					</div>
				</div>
			</div>

			<!-- Select All section -->
			<div
				class="px-3 py-2 border-b border-gray-200 dark:border-slate-700 flex-shrink-0"
			>
				<div class="flex items-center justify-between">
					<label class="inline-flex items-center cursor-pointer">
						<input
							type="checkbox"
							class="form-checkbox h-4 w-4 text-indigo-600 dark:text-indigo-400 transition duration-150 ease-in-out bg-white dark:bg-slate-700 border-gray-300 dark:border-slate-600 rounded focus:ring-indigo-500 dark:focus:ring-indigo-400"
							[checked]="filteredSelectAllChecked()"
							[indeterminate]="filteredIndeterminate()"
							(change)="toggleSelectAll($event)"
							(click)="$event.stopPropagation()"
						/>
						<span class="ml-2 text-gray-900 dark:text-gray-100">
							<ng-container
								*ngIf="!enableSearch() || !searchTerm()"
							>
								Check/Uncheck All
							</ng-container>
							<ng-container
								*ngIf="enableSearch() && searchTerm()"
							>
								Check/Uncheck All Filtered ({{
									filteredOptions().length
								}})
							</ng-container>
						</span>
					</label>
				</div>
			</div>

			<!-- Options list with scrollable area -->
			<div class="flex-1 overflow-y-auto min-h-0 scrollbar-thin">
				<div
					*ngFor="let option of filteredOptions()"
					[ngClass]="mergedOptionClass()"
				>
					<div class="flex items-center justify-between w-full gap-3">
						<!-- Checkbox and label - takes remaining space -->
						<label
							class="inline-flex items-center cursor-pointer flex-1 min-w-0"
						>
							<input
								type="checkbox"
								class="form-checkbox h-4 w-4 text-indigo-600 dark:text-indigo-400 transition duration-150 ease-in-out bg-white dark:bg-slate-700 dark:border-gray-600 border-gray-300 dark:border-slate-600 rounded focus:ring-indigo-500 dark:focus:ring-indigo-400 flex-shrink-0"
								[checked]="isSelected(option)"
								(change)="toggleOption(option, $event)"
								(click)="$event.stopPropagation()"
							/>
							<span class="ml-2 truncate">{{
								getOptionDisplay(option)
							}}</span>
						</label>

						<!-- Input field (if enabled) - fixed width at right edge -->
						<input
							*ngIf="enableInputFields()"
							[type]="inputType()"
							[value]="getInputValue(option)"
							[placeholder]="inputPlaceholder()"
							[readonly]="isInputReadonly(option)"
							[style.width]="inputWidth()"
							class="px-2 py-1 text-sm border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400 focus:border-transparent transition-colors flex-shrink-0 placeholder:text-gray-400 dark:placeholder:text-gray-500"
							[class.border-gray-300]="!isInputReadonly(option)"
							[class.dark:border-slate-600]="
								!isInputReadonly(option)
							"
							[class.bg-white]="!isInputReadonly(option)"
							[class.dark:bg-slate-700]="!isInputReadonly(option)"
							[class.text-gray-900]="!isInputReadonly(option)"
							[class.dark:text-gray-100]="
								!isInputReadonly(option)
							"
							[class.border-gray-200]="isInputReadonly(option)"
							[class.dark:border-slate-700]="
								isInputReadonly(option)
							"
							[class.bg-gray-50]="isInputReadonly(option)"
							[class.dark:bg-slate-800]="isInputReadonly(option)"
							[class.text-gray-500]="isInputReadonly(option)"
							[class.dark:text-gray-500]="isInputReadonly(option)"
							[class.cursor-not-allowed]="isInputReadonly(option)"
							(input)="onInputValueChange(option, $event)"
							(click)="$event.stopPropagation()"
						/>
					</div>
				</div>

				<!-- No results message -->
				<div
					*ngIf="
						enableSearch() &&
						searchTerm() &&
						filteredOptions().length === 0
					"
					class="px-3 py-4 text-center text-gray-500 dark:text-gray-400 text-sm"
				>
					No options found for "{{ searchTerm() }}"
				</div>
			</div>
		</div>
	</div>
</div>
